import { PRODUCT_IMAGES } from "../utils/imagesMap"

import {
  lydia,
  lilyana,
  candace,
  brian,
  lindsey,
  mark,
  neghin,
  tanya,
} from "./data_results_nova"

const mageURL = process.env.GATSBY_MAGENTO_URL || ""

export const data = {
  hero: {
    pill: `https://images.ctfassets.net/0rbfqd9c4jdo/1VW0Gi0Ke8l1DyTqYNi7uz/a7a71d7e593d359733b2b2098aad9837/pill-canvas__1_.png`,
    benefits: {
      women: {
        title: `For women 18-44 experiencing signs of hair thinning and shedding.`,
        items: [
          `Stress, imbalanced diets, and not getting enough sleep can impact your hair. This award-winning formula is proven to support faster-growing, visibly thicker, fuller, stronger hair.<sup>1,2</sup>`,
          `The clinically tested ingredients in Nutrafol Women target key root causes of thinning that come with leading a busy life.`,
        ],
      },
      balance: {
        title: `For women 45+ experiencing signs of hair thinning and shedding.`,
        items: [
          `Nutrafol Women’s Balance is the only hair growth supplement with published clinical studies in menopausal women with hair thinning.<sup>†</sup>`,
          `This formula is proven to improve hair growth by targeting key root causes of thinning, such as hormones and aging.<sup>3-5</sup>`,
        ],
      },
      postpartum: {
        title: `For postpartum or breastfeeding women who are experiencing signs of hair thinning.`,
        items: [
          `Developed by OBGYNs and breastfeeding-friendly, our Postpartum formula supports whole-body recovery and targets postpartum hair thinning caused by stress, hormonal changes, and nutrient depletion.<sup>6-9</sup>`,
          `Let your hair be one less thing to worry about.`,
        ],
      },
    },
    images: {
      women: `https://images.ctfassets.net/0rbfqd9c4jdo/1YrZ6wwV5Ni6k5UThrSMjo/52d43734035db351bc0d805c48a03c12/hero-women-circle.png`,
      balance: `https://images.ctfassets.net/0rbfqd9c4jdo/6ttJHOEclNxHtzmqRUQSth/e67a2137fc3d4709977969d2211bc05e/hero-balance-circle.png`,
      postpartum: `https://images.ctfassets.net/0rbfqd9c4jdo/7i3uezOZsHhOlsw5CAoTK4/54562c597330eaa8353e5dec65e4961c/hero-pospartum-circle.png`,
    },
    heading:
      "Hair health is <br/><span class='font-grilliItalic'>whole-body</span> health.",
    subheading: `Our hair growth formulas <span class='font-grilliItalic'>meet your body where it’s at.</span>`,
    tabs: [
      {
        label: "18-44 yrs.",
        value: "women",
      },
      {
        label: "45+ yrs.",
        value: "balance",
      },
      {
        label: "Postpartum",
        value: "postpartum",
      },
    ],
    buttons: {
      womenPcp: { label: "Shop Women", ctaLink: "/products/women/" },
      women: { label: "Shop Women", ctaLink: "/nutrafol-core-for-women/" },
      balance: { label: "Shop Balance", ctaLink: "/women-balance/" },
      postpartum: {
        label: "Shop Postpartum ",
        ctaLink: "/nutrafol-postpartum-for-women/",
      },
      men: { label: "Shop Men ", ctaLink: "/men/" },
      quiz: {
        label: "Take the Quiz for a Personalized Plan",
        ctaLink: `${mageURL}quiz/`,
      },
    },
  },
  heroA: {
    pill: `https://images.ctfassets.net/0rbfqd9c4jdo/1VW0Gi0Ke8l1DyTqYNi7uz/a7a71d7e593d359733b2b2098aad9837/pill-canvas__1_.png`,
    benefits: {
      women: {
        title: `For women 18-44 experiencing signs of hair thinning and shedding.`,
        items: [
          `Stress, imbalanced diets, and not getting enough sleep can impact your hair. This award-winning formula is proven to support faster-growing, visibly thicker, fuller, stronger hair.<sup>1,2</sup>`,
          `The clinically tested ingredients in Nutrafol Women target key root causes of thinning that come with leading a busy life.`,
        ],
      },
      balance: {
        title: `For women 45+ experiencing signs of hair thinning and shedding.`,
        items: [
          `Nutrafol Women’s Balance is the only hair growth supplement with published clinical studies in menopausal women with hair thinning.<sup>†</sup>`,
          `This formula is proven to improve hair growth by targeting key root causes of thinning, such as hormones and aging.<sup>3-5</sup>`,
        ],
      },
      postpartum: {
        title: `For postpartum or breastfeeding women who are experiencing signs of hair thinning.`,
        items: [
          `Developed by OBGYNs and breastfeeding-friendly, our Postpartum formula supports whole-body recovery and targets postpartum hair thinning caused by stress, hormonal changes, and nutrient depletion.<sup>6-9</sup>`,
          `Let your hair be one less thing to worry about.`,
        ],
      },
    },
    images: {
      women: `https://images.ctfassets.net/0rbfqd9c4jdo/1YrZ6wwV5Ni6k5UThrSMjo/52d43734035db351bc0d805c48a03c12/hero-women-circle.png`,
      balance: `https://images.ctfassets.net/0rbfqd9c4jdo/6ttJHOEclNxHtzmqRUQSth/e67a2137fc3d4709977969d2211bc05e/hero-balance-circle.png`,
      postpartum: `https://images.ctfassets.net/0rbfqd9c4jdo/7i3uezOZsHhOlsw5CAoTK4/54562c597330eaa8353e5dec65e4961c/hero-pospartum-circle.png`,
    },
    heading:
      "Hair growth starts <br/><span class='font-grilliItalic'> from the inside.</span>",
    subheading: `Our formulas <br class='show-md-up'/><span class='font-grilliItalic'>meet your body where it’s at.</span>`,
    tabs: [
      {
        label: "18-44 yrs.",
        value: "women",
      },
      {
        label: "45+ yrs.",
        value: "balance",
      },
      {
        label: "Postpartum",
        value: "postpartum",
      },
    ],
    buttons: {
      womenPcp: { label: "Shop Women", ctaLink: "/products/women/" },
      women: { label: "Shop Women", ctaLink: "/nutrafol-core-for-women/" },
      balance: { label: "Shop Balance", ctaLink: "/women-balance/" },
      postpartum: {
        label: "Shop Postpartum ",
        ctaLink: "/nutrafol-postpartum-for-women/",
      },
      men: { label: "Shop Men ", ctaLink: "/men/" },
    },
  },
  rootCauses: {
    title:
      "Healthy hair starts from within. Take a whole-body approach and <span class='font-grilliItalic'>target key root causes of hair thinning.</span>",
    causes: [
      {
        name: "Hormones",
        description:
          "DHT sensitivity can be caused by genetics, stress, poor diet, and toxins.",
        mobileOrder: 1,
        desktopOrder: 1,
      },
      {
        name: "Stress",
        description:
          "Physical or emotional stress like giving birth or a demanding job.",
        mobileOrder: 2,
        desktopOrder: 2,
      },
      {
        name: "Lifestyle",
        description:
          "Refers to your surroundings, the products you use, and the foods you eat.",
        mobileOrder: 3,
        desktopOrder: 4,
      },
      {
        name: "Metabolism",
        description:
          "Influences how hair follicles receive nutrients from the body.",
        mobileOrder: 4,
        desktopOrder: 5,
      },
      {
        name: "Nutrition",
        description:
          "Nutrient gaps that can result from a poor diet or a compromised gut microbiome.",
        mobileOrder: 5,
        desktopOrder: 3,
      },
      {
        name: "Aging",
        description:
          "Aging reduces the scalp’s collagen and elastin, weakening its grip on hair strands.",
        mobileOrder: 6,
        desktopOrder: 6,
      },
    ],
    cta: {
      label: "Take the Quiz to Find Your Root Causes",
      destination: `${process.env.GATSBY_MAGENTO_URL}quiz/`,
    },
  },
  rootCausesB: {
    title:
      "Take a whole-body approach and <span class='font-grilliItalic'>target root causes of hair thinning.</span>",
    causes: [
      {
        name: "Hormones",
        description:
          "DHT sensitivity can be caused by genetics, stress, poor diet, and toxins.",
        mobileOrder: 1,
        desktopOrder: 1,
      },
      {
        name: "Stress",
        description:
          "Physical or emotional stress like giving birth or a demanding job.",
        mobileOrder: 2,
        desktopOrder: 2,
      },
      {
        name: "Lifestyle",
        description:
          "Refers to your surroundings, the products you use, and the foods you eat.",
        mobileOrder: 3,
        desktopOrder: 4,
      },
      {
        name: "Metabolism",
        description:
          "Influences how hair follicles receive nutrients from the body.",
        mobileOrder: 4,
        desktopOrder: 5,
      },
      {
        name: "Nutrition",
        description:
          "Nutrient gaps that can result from a poor diet or a compromised gut microbiome.",
        mobileOrder: 5,
        desktopOrder: 3,
      },
      {
        name: "Aging",
        description:
          "Aging reduces the scalp’s collagen and elastin, weakening its grip on hair strands.",
        mobileOrder: 6,
        desktopOrder: 6,
      },
    ],
    cta: {
      label: "Take the Quiz to Find Your Root Causes",
      destination: `${process.env.GATSBY_MAGENTO_URL}quiz/`,
    },
  },
  products: {
    heading: "Find your formula",
    image: {
      mobile:
        "https://images.ctfassets.net/0rbfqd9c4jdo/6K2VzRCIPtbTfeXN4nizWS/2504a71f179703e29e951f46ee72cb71/prodlist-hero-mobile.jpg?fl=progressive",
      tablet:
        "https://images.ctfassets.net/0rbfqd9c4jdo/7BVx5S87U7MIbU9cFvpfit/e2dbf604617d2dde56e9f1009fc8c0a9/prodlist-hero-tablet.jpg?fl=progressive",
      desktop:
        "https://images.ctfassets.net/0rbfqd9c4jdo/1QVE9OPjiKSXYxDOVx2Zye/34f139347db3426cf7e8602a21765a3e/prodlist-hero.jpg?fl=progressive",
    },
    gwpColumn: {
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/3lLuLbeWX7Q7UaCluvTzHV/9dbbb7b448558f7b69b7fb549dbcc053/plane-graphic-women.png?fl=progressive",
      heading: "FREE travel-size samples<sup>‡</sup>",
      copy: "with a hair growth subscription.<br /> <i>Get yours before they're gone.</i>",
    },
    products: [
      {
        name: "Women",
        description: "For Women 18-44 experiencing signs of hair thinning",
        shortDescription: "For women<br/>18-44",
        image: `${PRODUCT_IMAGES.WOM1.label1}&w=400`,
        button: {
          url: "/nutrafol-core-for-women/",
          label: "Shop Women`s",
        },
      },
      {
        name: "Women's Balance",
        description: "For Women 45+ experiencing hair thinning",
        shortDescription: "For women<br/>45+",
        image: `${PRODUCT_IMAGES.BAL1.label1}&w=400`,
        button: {
          url: "/women-balance/",
          label: "Shop Balance",
        },
      },
      {
        name: "Women's Vegan",
        description: "For Women 18-44 with plant-based lifestyles",
        shortDescription: "For women<br/>18-44 plant-based",
        image: `${PRODUCT_IMAGES.VEG1.label1}&w=400`,
        button: {
          url: "/womens-vegan/",
          label: "Shop Women's Vegan",
        },
      },
      {
        name: "Postpartum",
        description:
          "For the first year post-birth experiencing hair thinning and shedding.",
        shortDescription: "For women<br/>post-childbirth",
        image: `${PRODUCT_IMAGES.POS1.label1}&w=400`,
        button: {
          url: "/nutrafol-postpartum-for-women/",
          label: "Shop Postpartum",
        },
      },
    ],
  },
  manifesto: {
    heading:
      "Trust isn't just<br class='hidden sm:block md:hidden' /> claimed.<br class='block sm:hidden md:block'/> It’s earned.",
    button: {
      label: "Learn About the Science",
      level: "Tertiary",
      destination: "/science/",
    },
    manifestoIntro: " Get hair growth you can trust.",
    items: [
      "We get it. The world of supplements is crowded with big talk and little proof. And when it comes to your health, blind faith isn’t an option. That’s why we don’t ask for it.",
      "At Nutrafol, we do things differently. We don’t just make claims—we back them up. With clinical studies. With doctor recommendations. With real, visible results. We hold ourselves to the highest scientific standards, because your trust isn’t something we take lightly.",
      "So go ahead—be skeptical. Read the research. Compare the ingredients. Hold us to the highest bar. We wouldn’t have it any other way.",
      "Because real science stands up to scrutiny. And real results speak for themselves. ",
    ],
  },
  growth: {
    title:
      "Start growing in as<span class='block sm:hidden'></span> little as 3-6 months",
    timeline: [
      {
        title: "Month 1-3",
        description:
          "Visibly fuller, healthier-looking hair. Visibly less shedding. Supported sleep quality.",
      },
      {
        title: "Month 4-6",
        description:
          "Visibly thicker hair growth. Faster-growing, longer, and stronger hair.",
      },
      {
        title: "Month 7+",
        description:
          "Continue to manage root causes of hair thinning. Maintain hair growth results.",
      },
    ],
    disclaimer: "Based on Women’s Hair Growth Nutraceutical",
  },
  results: {
    uid: "results-hp",
  },
  doctorQuotes: {
    heading: "Trusted by <span class='font-grilliItalic'>Doctors</span>",
    badge: {
      lineOne: "#1 Dermatologist-Recommended",
      lineTwo: "Hair Growth Supplement Brand*",
      classes: "text-center",
      widths: [210, null, 240],
    },
    quotes: [
      {
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/585ur1fd1oA7zWcShK8mZ1/86a694ad4e37ede99b5404e16dac1cc8/dr-julie-russak-headshot.jpg?fl=progressive",
        quote:
          "Nutrafol is a necessary part of my hair growth protocol since I have personally seen the positive impact it can have on the hair health of my clients.",
        name: "Dr. Julie Russak, M.D.",
        position: "FAAD Board-Certified Dermatologist",
      },
      {
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/6hldBeYvwTu7m96P0zywF3/73ed4f41555f75711263bf2653d5cb6e/dr-jeanine-downie-headshot2.jpg?fl=progressive",
        quote:
          "Quite frankly, I have never been a fan of any other hair or skin nutraceutical supplement before Nutrafol came along. This supplement really works, is consistent, and helps my patients from all races and ethnicities.",
        name: "Dr. Jeanine Downie, M.D.",
        position: "Board-Certified Dermatologist",
      },
      {
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/19QAzV3OWRb086Hi0zP5wM/85bb482c8736c6e52dd08e59a800cf22/dr-rawn-bosley-headshot.jpg?fl=progressive",
        quote:
          "As a physician, it is important that I rely on science when making recommendations for my patients. The clinical studies are clear; it works. My patients have experienced overwhelming satisfaction with Nutrafol, noting significant improvements in visible hair thickness and growth.",
        name: "Dr. Rawn Bosley, M.D. ",
        position: "Double Board-Certified Dermatologist",
      },
    ],
    legal: "Expert partners compensated for their opinion and experience.",
  },
  stats: {
    heading:
      "Clinical testing isn’t <span class='whitespace-nowrap font-grilliBook'>optional - </span><br/>it’s our standard.",
    button: {
      label: "Explore Our Clinical Trials",
      level: "Tertiary",
      destination: "/clinical/",
    },
    statsIntro:
      "Hair health innovations you can trust, thanks to industry-leading hair measurement.",
    stats: [
      {
        number: "90",
        suffix: "%",
        copy: "of women saw overall improvement in their hair after 6 months.<sup>2</sup>",
      },
      {
        number: "84",
        suffix: "%",
        copy: "of women saw less shedding after 6 months.<sup>2</sup>",
      },
      {
        number: "20",
        copy: "clinical studies, including randomized, placebo-controlled trials.<sup>10</sup>",
      },
    ],
  },
  faqAccordion: {
    heading:
      "We’re serious about facts. <br class='md:hidden xl:block' />Ask away.",
    accordions: [
      {
        title: "How do I get started?",
        content: `You're unique, and your hair growth plan should be too. That's why we created our <a class='quiz-link-external-faq' href='${process.env.GATSBY_MAGENTO_URL}quiz/' rel='noopener noreferrer'>Hair Wellness Quiz</a>—a quick 3-minute assessment that allows us to better understand your specific root causes of hair thinning and recommend a personalized product regimen that will give you results.`,
      },
      {
        title: "Is Nutrafol suitable for everyone?",
        content:
          "Not only is Nutrafol suitable for most people, but our hair growth supplements are specifically formulated to meet you where you are in life. We have 5 Nutraceutical formulas that are tailored to the bio-specific needs of men and women throughout all life stages: Women's, Women’s Vegan, Postpartum for the first year after childbirth or while breastfeeding, Women's Balance for peri- and postmenopause, and Men's.<br/><br/>Please note: We do not recommend Nutrafol to anyone under the age of 18. Also, while we have no reason to believe it's harmful, there have not been enough studies for us to say Nutrafol is suitable during pregnancy—so we recommend skipping it while pregnant or trying to conceive and sticking with Nutrafol Postpartum while breastfeeding. If you have a medical condition, or are taking medications (especially anticoagulant and blood-thinning drugs), please consult with your physician before taking Nutrafol.",
      },
      {
        title:
          "What is the difference between Nutrafol's Hair Growth Nutraceuticals?",
        content:
          "Our Hair Growth Nutraceuticals are clinically effective and physician-formulated to the bio-specific needs of men and women through all life stages and lifestyles.<sup>*</sup> The key root causes of thinning hair affect men and women differently and can change over time—so we created multiple formulas to give your hair exactly what it needs, when it needs it most.<br/><br/>Women’s formula focuses on addressing the key root causes of hair thinning for women 18-44 years old when stress, lifestyle habits, and nutrition play a heightened role in hair health.<br/><br/>Women’s Vegan is formulated for women 18-44 with the key root causes of thinning focusing on stress and lifestyle habits, plus it is optimized to support plant-based diet’s nutrition and absorption of nutrients in the body that affect hair health.<br/><br/>Women’s Balance is formulated for women 45+ to support the key root causes of hair thinning for women, such as stress, with optimized support for hormonal changes, such as menopause, that affect hair health.<br/><br/>Postpartum is OBGYN-formulated to address the key root causes of hair thinning and shedding for women within the first year of giving birth and through the time they are breastfeeding, such as the physical and emotional stress, hormonal changes, and nutritional support.<br/><br/>Men’s formula multi-targets the key root causes of thinning for men 18+, such as stress and poor nutrition, with optimized support of hair growth-inhibiting DHT hormone, without compromising sexual performance.",
      },
      {
        title: "Will Nutrafol work for my hair type?",
        content:
          "Nutrafol products were formulated to promote hair growth and hair wellness for all types of hair. While the characteristics of hair strands may vary by ethnicity, the underlying root causes that affect hair follicles can affect all people equally.<br/><br/>In a recent clinical study, we examined the effectiveness of Nutrafol in African American, Asian, Hispanic, and non-Hispanic men and women. All ethnicities saw less shedding after 2 months and improved thickness, growth rate, scalp coverage, and shine after 6 months of taking our Hair Growth Nutraceuticals.",
      },
      {
        title: "When can I expect to see results?",
        content:
          "Everyone's experience is different, but in our clinical studies, women showed results in 3-6 months. It's important to remember that healthy hair growth takes time—and of course, consistency is key. If you take Nutrafol daily, here's a snapshot of what you're likely to experience:<br/><br/><span class='font-dinamoBold'>1-3 months:</span> Strengthen hair from within. Look for shinier hair with less shedding and breakage.<br/><br/><span class='font-dinamoBold'>3-6 months:</span> You may notice improvement in fullness and volume.<br/><br/><span class='font-dinamoBold'>6+ months:</span> Experience visible changes like faster-growing hair that’s thicker and stronger with more scalp coverage.<br/><br/>Commitment to Nutrafol has whole-body rewards, too. Our ingredients are shown to promote more restful sleep, less stress, better mood, and clearer skin. A little something we call side benefits.",
      },
    ],
  },
  purposeScroll: {
    tag: {
      line: "FRIENDS AND FAMILY SALE",
      classes: "bg-nova-brand-accent-80",
    },
    videos: {
      mobile: {
        poster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/4ftcoJjwBZTC9fzfVbiWin/b9c3fbd2b27ad5e7ad79c526f6385c35/purpose-poster-mobile.jpg?fl=progressive",
        src: null,
      },
      desktop: {
        poster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/1rJYsGRDUouSsFUhYTTCtp/c30aac41b610e5c91cddd949c9b90a2b/purpose-poster-desktop.jpg?fl=progressive",
        src: null,
      },
    },
    headline:
      "We're deeply grateful for our customers—you’re the reason we do what we do.",
    copy: `You’re not on your hair growth journey alone. We’re dedicated to delivering science-backed products that help you—and our entire community—reach your full potential without ever settling for less. Rooted in innovation and fueled by purpose, we’re redefining hair and skin health with clinically tested, drug-free formulas that deliver real results. With over 1.5 million people growing with Nutrafol, our commitment to you—and to the highest standards in science—is stronger than ever.¹¹`,
    cta: {
      text: "Start Your Journey with 25% Off",
      icon: "Right",
      level: "Primary",
      url: "/fnf-offer/",
    },
  },
  //revert NT2-23062 FNF 2025 | Masterbrand HP - 3/27 purposeScrollWas->purposeScroll
  purposeScrollWas: {
    headline: "It’s not “just” hair.",
    copy: "We know firsthand the impact of hair thinning. We’ve experienced it, too. That’s why we’ve designed hair growth formulas that are tested, full of plant-based ingredients, and that actually work. Because you deserve results from a trusted partner - and a journey as unique as you are. Our commitment to you is simple: to help you feel your best, both inside and out. To show you how you can achieve your hair goals through whole-body health. And to be with you every step of the way. Our Shed the Silence community was created to ensure you’re never alone on your hair journey. It’s a place where you can share your experience with people who get it, offer support, and tackle hair struggles together. Because hair is never “just” hair. So, let’s keep growing together.",
    videos: {
      mobile: {
        poster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/4ftcoJjwBZTC9fzfVbiWin/b9c3fbd2b27ad5e7ad79c526f6385c35/purpose-poster-mobile.jpg?fl=progressive",
        src: "https://nutrafol.com/media/video_storage/purpose-video-mobile-optimized.mp4",
      },
      desktop: {
        poster:
          "https://images.ctfassets.net/0rbfqd9c4jdo/1rJYsGRDUouSsFUhYTTCtp/c30aac41b610e5c91cddd949c9b90a2b/purpose-poster-desktop.jpg?fl=progressive",
        src: "https://nutrafol.com/media/video_storage/purpose-video-desktop-optimized.mp4",
      },
    },
    cta: {
      text: "Join the community",
      url: "https://www.facebook.com/groups/shedthesilence",
    },
  },
  references: {
    content: `*${process.env.GATSBY_IQVIA_DATE}<br/>‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires the creation of a new Hair Growth Nutraceutical Subscription on nutrafol.com. Available to new subscribers only. Samples are a one-time delivery with initial subscription order. Samples are non-refundable or otherwise exchangeable for cash or product. Offer valid only on orders shipped within the United States. Not applicable to international orders. While supplies last.<br /><br />†Based on US publications in PubMed, Cochrane, and top Google Scholar and ScienceDirect results prior to Feb ‘21.<br/>1. Ablon G. J Drugs Dermatol. 2018. 2. Stephens T, et al. JCAD. 2022./Nutrafol. Data on file. 2020. 3. Ablon G, et al. J Drugs Dermatol. 2022. 4. Berkowitz S, et al. ASDS. 2020./Nutrafol. Data on file. 2020. 5. Ablon G, et al. J Drugs Dermatol. 2021. 6. Chandrashekar BS. J Res Derm. 2020. 7. Grothe T. Phytotherapy Res. 2020. 8. Tenore G. J Med Food. 2016. 9. Nutrafol. Data on file. 2023. 10. Nutrafol. Data on file. 2024. 10. Nutrafol. Data on file. 2024. 11. Nutrafol, Data on File, 2025.`,
  },
}
